<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" fullscreen persistent>
      <v-card class="risk-assessment scroll-form" height="100%">
        <v-card-title
          class="headline indigo darken-4 white--text fixed-header"
          primary-title
        >
          {{
            $vuetify.t('$vuetify.powra.pointOfWorkRiskAssessment').toUpperCase()
          }}
        </v-card-title>
        <v-layout row wrap>
          <PowraTitle
            :avatar="'C'"
            :title="$vuetify.t('$vuetify.powra.hazardsRisks')"
          />

          <v-flex xs12 px-3 class="font-weight-bold">
            {{ $vuetify.t('$vuetify.app.yes') }}
            <span class="ml-1">{{
              $vuetify.t('$vuetify.powra.hazardRisk')
            }}</span>
          </v-flex>

          <v-flex
            xs12
            px-3
            v-for="(hazard, i) in powraData.hazards"
            :key="hazard.code"
            :class="i % 2 == 0 ? '' : 'blue-grey lighten-5'"
          >
            <v-checkbox
              v-model="selectedHazards[hazard.code]"
              :value="hazard"
              class="py-0"
              color="red"
              @change="updateHazards(hazard.code)"
            >
              <div slot="label">
                {{ hazard.name }}
              </div>
            </v-checkbox>
          </v-flex>
        </v-layout>

        <powra-d
          v-on:newHazard="addHazard(...arguments)"
          :hazards="selectedHazards"
        ></powra-d>

        <div class="footer text-xs-center mb-3">
          <v-divider></v-divider>
          <v-card-text>
            <v-btn @click="back()">
              {{ $vuetify.t('$vuetify.calls.back') }}
            </v-btn>

            <v-btn color="success" @click="confirm()">
              {{ $vuetify.t('$vuetify.calls.proceedToTheNextSection') }}
            </v-btn>
            <abort-visit v-on:aborted="visitAborted(...arguments)" />
          </v-card-text>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="errorDialog" width="500">
      <v-card>
        <v-card-title class="headline red white--text" primary-title>
          {{ $vuetify.t('$vuetify.powra.checkHazardInputs') }}
        </v-card-title>
        <v-card-text>
          <v-container pa-1>
            <v-layout row>
              <v-flex shrink>
                <v-icon color="red" x-large>warning</v-icon>
              </v-flex>
              <v-flex pl-3>
                {{ $vuetify.t('$vuetify.powra.selectAtLeastOneHazard') }}
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="errorDialog = false">
            {{ $vuetify.t('$vuetify.app.ok') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AbortVisit from '@/components/AbortVisit.vue'
import PowraD from '@/components/powra/PowraD.vue'
import PowraTitle from '@/components/powra/PowraTitle.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import powraData from '../../data/forms/powra.json'

export default {
  props: ['show'],
  components: {
    AbortVisit,
    PowraD,
    PowraTitle
  },
  data() {
    return {
      dialog: false,
      errorDialog: false,
      selectedHazards: [],
      powraData,
      other_hazards: ''
    }
  },
  computed: {
    ...mapState({}),
    ...mapGetters({
      getActiveCall: 'calls/getActiveCall',
      hasPowra: 'calls/hasPowra',
      currentRiskAssessment: 'calls/currentRiskAssessment',
      getHazards: 'calls/getHazards',
      getControls: 'calls/getControls'
    }),
    callDetail() {
      return this.getActiveCall
    }
  },
  methods: {
    ...mapActions({
      saveRiskAssessmentHazards: 'calls/saveRiskAssessmentHazards'
    }),

    addHazard(hazard) {
      console.log('addHazard', hazard)
      // this.$set(this.selectedHazards, this.selectedHazards.length > 28 ? this.selectedHazards.length : 29, hazard)
      this.selectedHazards.other_hazards = {
        code: 'other_hazards',
        name: hazard
      }
      this.updateHazards('other_hazards')
    },
    // removeHazard(index) {
    //     this.selectedHazards.splice(index, 1)
    // },
    confirm() {
      if (Object.keys(this.selectedHazards).length === 0) {
        this.errorDialog = true
      } else {
        this.selectedHazards['other_hazards'] = this.other_hazards
        this.dialog = false
        this.$emit('confirmed', this.selectedHazards)
      }
    },
    visitAborted() {
      this.dialog = false
      this.$emit('aborted')
    },
    back() {
      this.dialog = false
      this.$emit('back')
    },
    populateActivePowraValues() {
      _.each(this.powraData.hazards, hazard => {
        if (this.getHazards[hazard.code]) {
          this.selectedHazards[hazard.code] = hazard
        }
      })
    },
    updateHazards(code) {
      this.saveRiskAssessmentHazards(this.selectedHazards)
    }
  },
  watch: {
    show: function(newVal, oldVal) {
      this.dialog = newVal
    },
    hasPowra: function() {
      if (this.hasPowra) {
        this.populateActivePowraValues()
      }
    }
  }
}
</script>

<style scoped>
.footer {
  position: -webkit-sticky;
  position: sticky;
  background-color: #ffffff;
  bottom: 0;
  width: 100%;
  height: 100px;
}

.fixed-header {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 300;
}

.scroll-form {
  height: 100%;
  position: relative;
  overflow-y: scroll;
}
</style>
